import React, { useState } from 'react';

import StockMobileSidePanel from '@/components/StockMobileSidePanel';
import { useTypedDispatch, useTypedSelector } from '@/store/store';
import {
  getSelectedFilters,
  getStockFilterParams,
  setCarColors,
  setPage,
} from '@/store/reducers/cars-stock';
import {
  getColorOptions,
  handleChangeColorMultiSelect,
} from '@/modules/CarsStock/components/common.helpers';
import { ColorOptionType } from '@/components/StockColorPicker/types';
import StockColorPickerSelect from '@/components/StockColorPickerSelect';

import {
  FilterButton,
  FilterButtonWrapper,
  MobileFilterItemWrapper,
} from '../../../../../../../common.styles';

function ColorFilter() {
  const dispatch = useTypedDispatch();
  const stockFilterParams = useTypedSelector(getStockFilterParams);
  const selectedColors =
    useTypedSelector(getSelectedFilters).selectedParams.selectedColors;
  const [isOpened, setOpened] = useState(false);

  const handleSidePanelOpen = () => {
    setOpened(true);
  };

  const handleSidePanelClose = () => {
    setOpened(false);
  };

  const colorOptions = getColorOptions(stockFilterParams);

  const handleChangeColor = (color: ColorOptionType) => {
    dispatch(setCarColors(handleChangeColorMultiSelect(color, selectedColors)));
    dispatch(setPage(1));
  };

  const handleClearColor = () => {
    dispatch(setCarColors([]));
    dispatch(setPage(1));
  };

  return (
    <StockMobileSidePanel
      title="Цвет"
      zIndex={10001}
      isInnerSidePanel
      isOpened={isOpened}
      onOpen={handleSidePanelOpen}
      onClose={handleSidePanelClose}
    >
      <MobileFilterItemWrapper>
        <StockColorPickerSelect
          colors={colorOptions}
          selectedColors={selectedColors}
          onChange={handleChangeColor}
          onClear={handleClearColor}
        />
      </MobileFilterItemWrapper>

      <FilterButtonWrapper>
        <FilterButton onClick={handleSidePanelClose}>Применить</FilterButton>
      </FilterButtonWrapper>
    </StockMobileSidePanel>
  );
}

export default ColorFilter;
